import { c as _c } from "react/compiler-runtime";
import { chakra } from '@chakra-ui/react';
import React from 'react';
export const CodeLeaf = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props.children) {
    t0 = <chakra.code>{props.children}</chakra.code>;
    $[0] = props.children;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};